import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/7a7c1d8c-08f7-477a-8220-e243a8f1503b";
export const REGISTER_URL = "https://a.ntrk2.com/3c45a497-5de7-4238-86b8-511b08ca3f9c";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://papa555.loadprkw2a.com/download?openExternalBrowser=1&id=r3w4u5r3yupo81d";

export * from "./codes";
export * from "./context";
